import React from 'react';
import { formatDateTime } from '@icims-design-system/i18next';
import { NearMeSharp } from '@mui/icons-material';
import Link from '@mui/material/Link';
import { format, zonedTimeToUtc } from 'date-fns-tz';
import { campaignTypes } from 'appConstants';
import {
  THIRTY_TO_SIXTY_DAYS,
  SIXTY_TO_NINETY_DAYS,
  NINETY_TO_ONEEIGHTY_DAYS,
  DAYS_AGO_CUSTOM,
  THIRTY,
  SIXTY,
  NINETY,
  ONEHUNDREDEIGHTY,
  NINE,
} from './constants';
import getMinutes from 'date-fns/getMinutes';
import getHours from 'date-fns/getHours';
import { path } from 'routes/path';
import { addCampaign, setCampaignJobData, updateCampaign } from 'redux/actions';

/* eslint-disable react/display-name */
export const getColumns = (t, classes, handleLinkClick) => [
  {
    id: 1,
    title: t('campaign_name', 'Campaign Name'),
    field: 'name',
    sortable: NearMeSharp,
    headerClassName: classes.CandidateNameHeader,
    ariaLabel: t('campaign_name', 'Campaign Name'),
    render: (_column, row) => (
      <Link
        tabIndex="0"
        component="button"
        data-testid="campaign-name"
        className={classes.campaignLink}
        onClick={() => handleLinkClick(row)}
      >
        {row.data.campaignName}
      </Link>
    ),
  },
  {
    id: 2,
    title: t('campaign_code', 'Campaign Code'),
    field: 'code',
    sortable: true,
    headerClassName: classes.PhoneNumberHeader,
    ariaLabel: t('campaign_code', 'Campaign Code'),
    render: (_column, row) => row.data.campaignCode,
  },
  {
    id: 3,
    title: t('candidates', 'Candidates'),
    field: 'candidateCount',
    sortable: false,
    ariaLabel: t('candidates', 'Candidates'),
    headerClassName: classes.tagsHeader,
    render: (_column, row) => row.data.candidateCount,
  },
  {
    id: 4,
    title: t('created_at', 'Created At'),
    field: 'id',
    sortable: true,
    ariaLabel: t('created_at', 'Created At'),
    render: (_column, row) => formatDateTime(row.data.created, 'keyboardDateTime'),
  },
];

export const getCampaignRowData = (campaigns, t) =>
  campaigns.map((campaign) => ({
    id: campaign.id,
    data: {
      campaignName: campaign.name,
      campaignCode: campaign.code,
      candidateCount: campaign.candidateCount,
      created: campaign.created,
    },
    activateAriaLabel: (row) =>
      t('candidate-list:table.selectRowAriaLabel', 'Select {{name}}', {
        name: row.data.campaignName,
      }),
  }));

export function getAPIEndDateFormat({ time, timezone }) {
  const currentDate = `${format(new Date(), 'yyyy-MM-dd')}T${time}`;
  const formatTimeToUTC = zonedTimeToUtc(currentDate, timezone);
  return formatTimeToUTC.toISOString();
}

export const nameFormatter = (option) => {
  // autocomplete returns name and info in option, will show name and info both
  //	else will show name entered as input
  const { name = '', info = '' } = option;
  if (name && info) {
    return `${name} < ${info} >`;
  }
  return name;
};

export const lastContactedDaysAgo = (job) => {
  let lastContactedDays = '';
  const { minDays, maxDays } = job.candidateQuery.lastContacted;
  if (job.type === campaignTypes.REENGAGEMENT) {
    if (minDays === THIRTY && maxDays === SIXTY) {
      lastContactedDays = THIRTY_TO_SIXTY_DAYS;
    } else if (minDays === SIXTY && maxDays === NINETY) {
      lastContactedDays = SIXTY_TO_NINETY_DAYS;
    } else if (minDays === NINETY && maxDays === ONEHUNDREDEIGHTY) {
      lastContactedDays = NINETY_TO_ONEEIGHTY_DAYS;
    } else {
      lastContactedDays = DAYS_AGO_CUSTOM;
    }
  }
  return lastContactedDays;
};

export const lastContactedOptions = [
  {
    name: THIRTY_TO_SIXTY_DAYS,
    value: THIRTY_TO_SIXTY_DAYS,
  },
  {
    name: SIXTY_TO_NINETY_DAYS,
    value: SIXTY_TO_NINETY_DAYS,
  },
  {
    name: NINETY_TO_ONEEIGHTY_DAYS,
    value: NINETY_TO_ONEEIGHTY_DAYS,
  },
  {
    name: DAYS_AGO_CUSTOM,
    value: DAYS_AGO_CUSTOM,
  },
];

export function currentTime() {
  // prefix 0 if time is less than 10 minutes, as SB expects time in 2 digits.
  const minutes =
    getMinutes(new Date()) > NINE ? getMinutes(new Date()) : `0${getMinutes(new Date())}`;
  const hours = getHours(new Date()) > NINE ? getHours(new Date()) : `0${getHours(new Date())}`;
  return `${hours}:${minutes}`;
}

export const getJobSequenceId = (job) => {
  const { outboundSequence = {} } = job;
  const { sequenceDefinitionId = '' } = outboundSequence;

  return sequenceDefinitionId;
};

export const saveCampaignHelper = ({ campaignData, jobId, reEngagementCallBack, ariSequence }) => {
  const campaignDetails = {
    campaignName: campaignData.campaignName,
    jobCode: campaignData.jobCode,
    sequence: ariSequence,
    isAri: campaignData.isAri,
    isReengagement: campaignData.isReengagement,
    url: campaignData.url,
    autoResponse: campaignData.automaticResponse,
    jobId,
  };
  reEngagementCallBack(campaignData, campaignDetails);
};

export const reEngagementCallBackHelper = ({
  campaignData,
  campaignDetails,
  setshowRengageMentModal,
  campaignJobData,
  dispatch,
  jobId,
}) => {
  if (campaignData.isReengagement) {
    setshowRengageMentModal(true);
    dispatch(
      setCampaignJobData({
        campaignJobData: {
          ...campaignJobData,
          ...campaignDetails,
        },
      }),
    );
  } else if (jobId) {
    dispatch(updateCampaign(campaignDetails));
  } else {
    dispatch(addCampaign(campaignDetails));
  }
};
export const cancelCampaignHelper = ({ jobId, history, locationState }) => {
  if (jobId) {
    return history.push(`${path.CAMPAIGNS}/${jobId}`);
  }
  if (locationState.redirectTo) {
    return history.push(locationState.redirectTo);
  }
  return history.push(path.CAMPAIGNS);
};
